export default __webpack_public_path__ + "static/map_with_badge-9335ed5834a0eeb8dc89666753b384a9.webp";